import React from "react";

const WiFi = () => {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.737674 3.51541C0.8372 3.62802 0.993598 3.62313 1.09786 3.50562C2.26848 2.22773 3.80876 1.55207 5.52914 1.55207C7.26374 1.55207 8.80876 2.22773 9.97464 3.51541C10.0742 3.61823 10.2258 3.61334 10.3254 3.50562L10.9889 2.81527C11.0836 2.71735 11.0836 2.59005 11.0078 2.49702C9.86564 1.04287 7.73767 0 5.52914 0C3.32535 0 1.19265 1.03798 0.0552092 2.49702C-0.0206202 2.59005 -0.0206202 2.71735 0.0694272 2.81527L0.737674 3.51541ZM2.71872 5.5522C2.83246 5.66481 2.98412 5.65502 3.09312 5.53261C3.67132 4.88143 4.59549 4.42119 5.53388 4.42609C6.47701 4.42119 7.40118 4.89122 7.9936 5.5473C8.09312 5.66481 8.2353 5.65991 8.34431 5.5473L9.08838 4.7933C9.17843 4.70517 9.18791 4.58277 9.10734 4.48484C8.368 3.55948 7.01729 2.89361 5.53388 2.89361C4.04573 2.89361 2.69502 3.55948 1.95568 4.48484C1.87511 4.58277 1.88459 4.70027 1.97464 4.7933L2.71872 5.5522ZM5.53388 8.26465C5.64763 8.26465 5.74715 8.21079 5.94146 8.01984L7.1026 6.86436C7.18791 6.78112 7.20687 6.64403 7.13104 6.54611C6.79928 6.11036 6.19739 5.75783 5.53388 5.75783C4.85142 5.75783 4.24004 6.12504 3.91303 6.58528C3.85616 6.67341 3.88459 6.78112 3.96516 6.86436L5.1263 8.01984C5.31587 8.20589 5.42014 8.26465 5.53388 8.26465Z"
        fill="#1C1C1E"
      />
    </svg>
  );
};

export default WiFi;
